
const sourceSelectorTypes = {
    NORMAL: 'NORMAL',
    MATRIX: 'MATRIX'
}

export {
    sourceSelectorTypes
}